import LegalPage, { ShieldCheck } from "@/pages/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      slug="privacy"
      defaultTitle="Política de Privacidade"
      badge="Documento Legal"
      icon={ShieldCheck}
      siblingSlug="termos-de-uso"
      siblingLabel="Ver Termos de Uso"
    />
  );
}
